var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrush1SvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -0.5 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-brush-1",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "880"), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 0.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.056,8.306 L4.364,4.955 L11.067,11.66 L7.717,15.968 C7.717,15.968 7.761,14.914 6.28,14.531 C4.89,14.172 4.648,12.243 3.437,11.843 C2.226,11.443 2.011,10.601 1.451,9.698 C0.891,8.795 0.056,8.306 0.056,8.306 L0.056,8.306 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.981,7.83 L11.835,6.684 C13.676,5.081 15.114,3.782 15.372,3.522 C16.167,2.729 16.165,1.444 15.372,0.651 C14.579,-0.143 13.292,-0.143 12.499,0.649 C12.241,0.909 10.94,2.346 9.339,4.189 L8.193,3.043 C7.664,2.514 6.806,2.513 6.277,3.042 L5.32,3.999 L12.024,10.704 L12.982,9.745 C13.51,9.217 13.51,8.358 12.981,7.83 L12.981,7.83 Z M13.246,2.777 C12.863,2.394 12.863,1.775 13.246,1.393 C13.627,1.011 14.246,1.012 14.629,1.394 C15.012,1.777 15.012,2.396 14.629,2.777 C14.247,3.16 13.629,3.16 13.246,2.777 L13.246,2.777 Z",
    className: "si-glyph-fill"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush1SvgrepoCom);
export default __webpack_public_path__ + "static/media/brush-1-svgrepo-com.b7bb7aca01e2ae7fc6f5bd3bb7b87a4f.svg";
export { ForwardRef as ReactComponent };